import { apiHost } from '../../../config';
import { get } from '../../requests';

export default async function getAllStudents() {
  return get(`${apiHost}/api/teacher/users`);
}
